import { createContext, useContext, useEffect } from "react";
import useDataPersistent from "../hooks/usedataPersistant";

const LuftProgressContext = createContext({});

export const LuftProgressContextProvider = ({ children }) => {
    const markersIds = [
        "learn-luft-html-marker-tree",
        "learn-luft-html-marker-sky",
        "learn-luft-html-marker-galaxy",
        "learn-luft-html-marker-cycle",
        "luft-tom-message-icon",
        "luft-tom-message-1",
        "luft-tom-message-2",
        "luft-tom-message-3",
        "luft-lola-message-icon",
        "luft-lola-message-1",
        "luft-lola-message-2",
    ];

    const [clickedMarkers, setClickedMarkers] = useDataPersistent("clickedMarkersLuft", []);
    const [progress, setProgress] = useDataPersistent("progressLuft", 0);

    useEffect(() => {
        // Recalculate progress on page load based on clicked markers
        const totalMarkers = markersIds.length;
        const currentProgress = clickedMarkers.length / totalMarkers;
        setProgress(currentProgress);
    }, [clickedMarkers, markersIds.length, setProgress]); // Runs when component mounts and when clickedMarkers change

    const countPercentage = (id) => {
        if (!markersIds.includes(id)) {
            return progress;
        }

        if (clickedMarkers.includes(id)) {
            return progress;
        }

        setClickedMarkers((prev) => [...prev, id]);

        return (clickedMarkers.length + 1) / markersIds.length;
    };

    return (
        <LuftProgressContext.Provider value={{ countPercentage, clickedMarkers, progress }}>
            {children}
        </LuftProgressContext.Provider>
    );
};

export const useLuftProgress = () => {
    return useContext(LuftProgressContext);
};
